import { Component, OnInit, Input,AfterContentChecked } from '@angular/core'
import { CpmService } from 'app/service/cpm.service'

@Component({
  selector: 'app-shareholder-info',
  templateUrl: './shareholder-info.component.html',
  styleUrls: ['./shareholder-info.component.scss']
})
export class ShareholderInfoComponent implements OnInit,AfterContentChecked {
  result = null
  shareHolderTableOptions: DataTables.Settings = {}
  shareholderHeader = [
    'Symbol',
    'No. of share (M.shares)',
    '% Share',
    'Latest book closing date'
  ]

  @Input('firstName') firstName: any
  @Input('lastName') lastName: any

  constructor(private cpmService: CpmService) { }

  ngOnInit() {
    this.shareHolderTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      columnDefs: [{ targets: 3, orderData: 4 }, { targets: 4, visible: false }],
      scrollY: '450px',
      scrollCollapse: true
    }
    this.getShareholderInformation()
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }

  async getShareholderInformation() {
    await this.cpmService
      .getShareholderInformation(this.firstName, this.lastName)
      .then(res => {
        this.result = res
        $('#loadingInfo').hide()
      })
      .catch(() => {
        $('#loadingInfo').text('Error occurs while fetching data...')
      })
  }

  treatedData() {
    return this.result.shareHolder.length > 0 ? this.result.shareHolder : null
  }

  getData(responseData) {
    return responseData === null ? ' - ' : responseData
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/shareholder/shareholder-info/shareholder-info.component.ts